import type { NextRequest } from "next/server";

export const useSecureCookies = (req?: NextRequest) => {
  if (typeof window !== "undefined") {
    return window.location.protocol === "https:";
  }
  return req?.nextUrl.protocol === "https:";
};
